<template>
  <el-dialog
    title="翻译管理"
    :visible.sync="dialogVisible"
    width="60%"
    class="newAdd"
    :close-on-click-modal="false"
    @open="loadTranslations">

    <div class="addUser_body">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="English" name="en">
          <el-form :model="translations.en" label-width="150px">
            <el-form-item v-for="field in fields" :key="field.name" :label="field.label">
              <el-input
                v-if="field.type === 'input'"
                v-model="translations.en[field.name]"
                :placeholder="'请输入' + field.label + '的英文翻译'">
              </el-input>
              <el-input
                v-else
                type="textarea"
                :rows="3"
                v-model="translations.en[field.name]"
                :placeholder="'请输入' + field.label + '的英文翻译'">
              </el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>

        <el-tab-pane label="Deutsch" name="de">
          <el-form :model="translations.de" label-width="150px">
            <el-form-item v-for="field in fields" :key="field.name" :label="field.label">
              <el-input
                v-if="field.type === 'input'"
                v-model="translations.de[field.name]"
                :placeholder="'请输入' + field.label + '的德文翻译'">
              </el-input>
              <el-input
                v-else
                type="textarea"
                :rows="3"
                v-model="translations.de[field.name]"
                :placeholder="'请输入' + field.label + '的德文翻译'">
              </el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>

        <el-tab-pane label="繁體中文" name="zh-Hant">
          <el-form :model="translations['zh-Hant']" label-width="150px">
            <el-form-item v-for="field in fields" :key="field.name" :label="field.label">
              <el-input
                v-if="field.type === 'input'"
                v-model="translations['zh-Hant'][field.name]"
                :placeholder="'请输入' + field.label + '的繁体中文翻译'">
              </el-input>
              <el-input
                v-else
                type="textarea"
                :rows="3"
                v-model="translations['zh-Hant'][field.name]"
                :placeholder="'请输入' + field.label + '的繁体中文翻译'">
              </el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="saveTranslations" :loading="saving">确定</el-button>
      <el-button @click="dialogVisible = false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import Qs from 'qs'

export default {
  name: 'I18nTranslationDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    entityType: {
      type: String,
      required: true
    },
    entityId: {
      type: Number,
      default: null
    },
    fields: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      dialogVisible: false,
      activeTab: 'en',
      saving: false,
      translations: {
        en: {},
        de: {},
        'zh-Hant': {}
      }
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
    }
  },
  methods: {
    // 初始化空翻译对象
    initTranslations() {
      var en = {}
      var de = {}
      var zhHant = {}
      this.fields.forEach(function(field) {
        en[field.name] = ''
        de[field.name] = ''
        zhHant[field.name] = ''
      })
      this.translations = { en: en, de: de, 'zh-Hant': zhHant }
    },

    // 加载已有翻译
    loadTranslations() {
      this.initTranslations()
      if (!this.entityId) return

      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.entityType = this.entityType
      data.entityId = this.entityId
      data.sign = Vue.prototype.FunGetSign(data)

      axios.get(Vue.prototype.global.Url_I18nList, { params: data })
        .then(function(response) {
          if (response.data.code === 1 && response.data.data) {
            var serverData = response.data.data
            var languages = ['en', 'de', 'zh-Hant']
            languages.forEach(function(lang) {
              if (serverData[lang]) {
                Object.keys(serverData[lang]).forEach(function(fieldName) {
                  if (that.translations[lang].hasOwnProperty(fieldName)) {
                    that.translations[lang][fieldName] = serverData[lang][fieldName]
                  }
                })
              }
            })
          }
        })
        .catch(function(error) {
          console.log('加载翻译失败:', error)
        })
    },

    // 保存翻译
    saveTranslations() {
      var that = this
      that.saving = true

      var languages = ['en', 'de', 'zh-Hant']
      var promises = []

      languages.forEach(function(lang) {
        var filteredTranslations = {}
        var hasContent = false
        Object.keys(that.translations[lang]).forEach(function(key) {
          if (that.translations[lang][key] && that.translations[lang][key].trim() !== '') {
            filteredTranslations[key] = that.translations[lang][key]
            hasContent = true
          }
        })

        if (hasContent) {
          var requestData = {
            entityType: that.entityType,
            entityId: that.entityId,
            language: lang,
            translations: filteredTranslations
          }

          var signData = Vue.prototype.FunGetBaseSignData()
          signData.sign = Vue.prototype.FunGetSign(signData)
          var queryString = Qs.stringify(signData)

          promises.push(
            axios.post(
              Vue.prototype.global.Url_I18nSave + '?' + queryString,
              requestData,
              { headers: { 'Content-Type': 'application/json' } }
            )
          )
        }
      })

      if (promises.length === 0) {
        that.saving = false
        that.dialogVisible = false
        return
      }

      Promise.all(promises)
        .then(function(responses) {
          that.saving = false
          var allSuccess = responses.every(function(r) { return r.data.code === 1 })
          if (allSuccess) {
            that.$message.success('翻译保存成功')
            that.dialogVisible = false
          } else {
            that.$message.error('部分翻译保存失败')
          }
        })
        .catch(function(error) {
          that.saving = false
          that.$message.error('保存翻译失败')
          console.log(error)
        })
    }
  }
}
</script>

<style scoped>
.addUser_body {
  padding: 0 20px;
}
</style>
